<style lang="less" scoped>
  @import "../../../../style/theme.less";

</style>

<template>
  <a-modal
    :visible="showCreateReportBlockModal"
    :closable="false"
    :confirm-loading="isLoading"
    title="Create Report Block"
    width="90%"
  >
    <template slot="footer">
      <a-button key="back" @click="close">
        Close
      </a-button>
      <a-button type="primary" key="submit" @click="createReportBlock">
        Save and Close
      </a-button>
    </template>

    <a-alert v-if="error.show" :message="error.message" type="info" show-icon style="margin-bottom: 16px;" />

    <a-form :label-col="{ span: 2 }" :wrapper-col="{ span: 21 }">
      <a-form-item label="Index">
        <a-input-number
          :min="1"
          placeholder="Index"
          style="width: 300px;"
          :value="createReportBlockInputs.index"
          @change="setCreateReportBlockIndex"
        />
      </a-form-item>

      <a-form-item label="Name">
        <a-input
          placeholder="Name"
          style="width: 300px;"
          :value="createReportBlockInputs.descriptor"
          @change="({ srcElement: { value }}) => setCreateReportBlockDescriptor(value)"
        />
      </a-form-item>

      <a-form-item label="Conditions">
        <conditions-editor
          ref="conditionsEditor"
          :conditions="createReportBlockInputs.conditions"
          @change="setCreateReportBlockConditions"
        />
      </a-form-item>

    </a-form>

  </a-modal>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

import conditionsEditor from '../../../../components/shared/conditions/editor';

export default {
  name: 'admin.report-types.create-report-block-modal',

  data: () => ({

  }),

  components: {
    conditionsEditor,
  },

  mounted() {
    return this.listPersonalityTraits();
  },

  watch: {
  },

  computed: {
    ...mapState('admin', ['showCreateReportBlockModal', 'personalityTraits', 'createReportBlockInputs', 'error',]),
    ...mapGetters('admin', ['isLoading',]),
  },

  methods: {
    ...mapActions('admin', ['listPersonalityTraits', 'createReportBlock',]),
    ...mapMutations('admin', [
      'setShowCreateReportBlockModal',
      'clearCreateReportBlockInputs',
      'setCreateReportBlockIndex',
      'setCreateReportBlockDescriptor',
      'setCreateReportBlockConditions',
    ]),

    close() {
      this.clearCreateReportBlockInputs();
      this.setShowCreateReportBlockModal(false);
    },
  },
};
</script>
